<template>
  <v-container fluid>


    <EtablissementItem
        v-if="etablissement!== null && !searching"
        v-bind:etablissement="etablissement"
    />

      <v-progress-circular
        v-if="searching"
        indeterminate
        color="primary"
    ></v-progress-circular>


  </v-container>

</template>

<script>
import EtablissementItem from '@/components/etablissement/EtablissementItem';


export default {
  name: "Etablissement",
  components: {
    EtablissementItem,
  },
  props: ['siret']
  ,
  data() {
    return {
      currentsiret: "",
      oldsiret: ""
    }
  },
  computed: {
    etablissement() {
      return this.$store.state.etablissement
    },
    searching() {
      return this.$store.state.searchingEtab
    }
  },
  beforeMount() {
    this.currentsiret = this.siret
    this.oldsiret = this.siret
    if (this.currentsiret != "") {
      this.searchetablissement(this.siret)
    }
  },
  mounted() {
    if (this.siret != this.oldsiret && this.siret === undefined) {
      this.oldsiret = this.siret
      this.searchetablissement(this.siret)
    }
  },
  beforeUpdate() {
    if (this.siret != this.currentsiret && !this.siret === undefined && this.siret != "") {
      this.oldsiret = this.siret
      this.currentsiret = this.siret
      this.searchetablissement(this.currentsiret)
    }

  },

  methods: {
    searchetablissement(siret) {
      if (siret) {
        // get data from store
        this.$store.dispatch('getEtablissement', this.siret)


      }
    },
    search(searchParams) {
      this.siret = searchParams.join(' ');
      this.searchetablissement(this.siret)
    },


  }
}
</script>

<style scoped>


</style>